import { Swiper, SwiperSlide } from "swiper/react";
import React, { useState } from "react";
import CardsComponent from "../common/cards";
import AccordionComponent from "./accordion";

// import required modules
import { Grid, Pagination } from "swiper";
import RectcardComponent from "../home/accordion/rect-card";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getUniqueObjByKey } from "../../services/common/utils";
import { GTM_Select_Item } from "../../../src//analytics/GoogleTagManager";
import CardDLS from "./card-dls";
import ExclusiveModal from "./exclusive-modal";

const SwiperComponent = ({ type, data, addonsId, psmItem, categoryId, section, bgColor="", categoryId_ar, categoryId_en, giftnumber, flag="false" }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [displaytext, setDisplayText] = useState();
  const pathString = location?.pathname?.split("/")[1];
  //for speacial offers at home page
  if (type === 1) {
    return (
      <Swiper
        className="rect_card_swiper_1 mb-2"
        spaceBetween={12}
        slidesPerView={data?.response?.length > 3 ? 1.1 : 1}
        pagination={{
          clickable: true
        }}
        // slidesPerView={1.1}
        // grid={{ rows: 3, fill: "row" }}
        // grid={{ rows: 1, fill: "row" }}
        grid={{ rows: 3, fill: "row" }}
        modules={[Grid, Pagination]}
      >
        {data?.response?.map((item) => {
          return (
            <SwiperSlide>
              <CardsComponent
                type={6}
                data={item}
                psmItem={psmItem}
              ></CardsComponent>
            </SwiperSlide>
          );
        })}
      </Swiper>
    );
  }

  // Special deals swiper
  if (type === 2) {
    //console.log("SwiperComponent_type_2_data ==> ", data);

    return (
      <>
        {
          data?.response === null ||
            data?.response === undefined ||
            data?.response === "" ||
            // data?.response === [] ||
            data?.response?.length == 0 ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> :
            <Swiper className="auto_swiper_1" spaceBetween={12} slidesPerView="auto">
              {data?.response?.map((item) => {
                return (
                  <SwiperSlide>
                    <CardsComponent type={1} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
              {/* <SwiperSlide>
            <CardsComponent type={1}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
            <CardsComponent type={1}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
            <CardsComponent type={1}></CardsComponent>
        </SwiperSlide> */}
            </Swiper>
        }
      </>
    );
  }

  if (type === 3) {
    return (
      <Swiper
        className="column_swiper_1"
        spaceBetween={12}
        slidesPerView={1.1}
        grid={{ rows: 3, fill: "row" }}
        modules={[Grid, Pagination]}
      >
        <SwiperSlide>
          <CardsComponent type={3}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={3}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={3}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={3}></CardsComponent>
        </SwiperSlide>
      </Swiper>
    );
  }

  if (type === 4) {
    //console.log("SwiperComponent_type_4_data", data);
    return (
      <Swiper
        className="column_swiper_1 swiper_vertical_slide"
        spaceBetween={12}
        slidesPerView={data?.length > 3 ? 1.1 : 1}
        grid={{ rows: 3, fill: "row" }}
        modules={[Grid, Pagination]}
      >
        {data?.map((item) => {
          return (
            <SwiperSlide>
              {
                pathString === 'recent-Transaction-Home' ? (
                  <CardsComponent type={34} data={item}></CardsComponent>
                ) : (
                  <CardsComponent type={2} data={item}></CardsComponent>
                )
              }
            </SwiperSlide>
          );
        })}
        {/* <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide> */}
      </Swiper>
    );
  }

  // Digital Services Swiper
  if (type === 5) {
    return (
      <>
        {
          data?.response === null ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> :
            <Swiper
              className="column_swiper_1 swiper_vertical_slide"
              spaceBetween={12}
              slidesPerView={
                data?.response?.length > 0
                  ? data?.response[0]?.sections[0]?.services?.length > 3
                    ? 1.1
                    : 1
                  : 1
              }
              grid={{ rows: 3, fill: "column" }}
              modules={[Grid, Pagination]}
              style={{ gridAutoFlow: "row", display: "grid" }
              }
            >
              {data?.response?.length > 0 &&
                data?.response[0]?.sections[0]?.services?.slice(0, 6)?.map((item) => {
                  return (
                    <SwiperSlide>
                      <CardsComponent type={4} data={item}></CardsComponent>
                    </SwiperSlide>
                  );
                })}


              {/* <SwiperSlide>
            <CardsComponent type={4}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
            <CardsComponent type={4}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
            <CardsComponent type={4}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
            <CardsComponent type={4}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
            <CardsComponent type={4}></CardsComponent>
        </SwiperSlide> */}
            </Swiper>
        }
      </>
    );
  }

  if (type === 6) {
    return (
      <Swiper className="auto_swiper_1" spaceBetween={12} slidesPerView="auto">
        <SwiperSlide>
          <CardsComponent type={5}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={5}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={5}></CardsComponent>
        </SwiperSlide>
      </Swiper>
    );
  }

  if (type === 7) {
    return (
      <Swiper
        className="column_swiper_1"
        spaceBetween={12}
        slidesPerView={1.1}
        grid={{ rows: 3, fill: "row" }}
        modules={[Grid, Pagination]}
      >
        <SwiperSlide>
          <CardsComponent type={8}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={8}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={8}></CardsComponent>
        </SwiperSlide>
        <SwiperSlide>
          <CardsComponent type={8}></CardsComponent>
        </SwiperSlide>
      </Swiper>
    );
  }
  if (type === 8) {
    let x = null
    return (
      <>
        {
          data?.response === null ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> :
            <Swiper
              className="column_swiper_1 swiper_vertical_slide"
              spaceBetween={12}
              style={{ gridAutoFlow: "row", display: "grid" }
              }
              slidesPerView={data?.response?.length > 3 ? 1.1 : 1}
              grid={{ rows: 3, fill: 'column' }}
              modules={[Grid, Pagination]}
            >
              {/* {console.log(
          data?.response?.slice(0, 6),
          "data?.response?.filter(item => item.length <= 6)"
        )} */}
              {
                data?.response?.slice(0, 6).map((item, i) => {
                  // console.log(data, "datesrrrr");
                  return (
                    <SwiperSlide
                      // style={{ display: "flex", order: i + 1 !== 1 ? ((i + 1) / 2 === 1 ? i + 1 : i -1) : 1 }}
                      onClick={() => {
                        try{
                          GTM_Select_Item(item, "addons")
                        }catch{}  
                        navigate(
                          `/addons-detail/${data.id !== undefined ? data.id : item?.rnofferSubGroup
                          }`,
                          { state: item }
                        );

                      }}
                    >
                      <CardsComponent type={9} data={item}></CardsComponent>
                    </SwiperSlide>
                  );
                })
              }
            </Swiper >
        }
      </>
    );
  }

  // roaming swiper 
  if (type === 9) {
    return (
      <>
        {
          data?.response === null ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> :
            <Swiper
              className="column_swiper_1 swiper_vertical_slide"
              spaceBetween={6}
              // slidesPerView={data?.response?.length <= 2 ? "auto" : 1.1}
              slidesPerView="auto"
              grid={{ cols: 3, fill: "col" }}
              modules={[Grid, Pagination]}
            >
              {data?.response?.map((item) => {
                return (
                  <SwiperSlide className="w-50">
                    <CardsComponent type={10} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </Swiper>
        }
      </>
    );
  }

  // if(type===8){
  //     return <Swiper className='column_swiper_1'
  //     spaceBetween={12}
  //     slidesPerView={1}
  //     grid={{ rows: 1, fill: "row" }}
  //     modules={[Grid, Pagination]}
  //     >
  //     <SwiperSlide>
  //         <AccordionComponent type={2}></AccordionComponent>
  //     </SwiperSlide>
  //     <SwiperSlide>
  //          <AccordionComponent type={2}></AccordionComponent>
  //     </SwiperSlide>
  //     <SwiperSlide>
  //      <AccordionComponent type={2}></AccordionComponent>
  //     </SwiperSlide>
  // </Swiper>
  // }

  // if(type===9){
  //     return <div>
  //     <CardsComponent type={10}></CardsComponent>
  //     </div>
  // }

  // if(type===10){
  //     return <Swiper className='column_swiper_1'
  //     spaceBetween={12}
  //     slidesPerView={1}
  //     grid={{ rows: 1, fill: "row" }}
  //     modules={[Grid, Pagination]}
  //     >
  //     <SwiperSlide>
  //         <CardsComponent type={11}></CardsComponent>
  //     </SwiperSlide>
  // </Swiper>
  // }
  if (type === 11) {
    // const detailsPage = (offerItem) => {
    //   navigate(`/roaming-deals-detail/${offerItem?.offerid}`, {
    //     state: {
    //       psmItem: psmItem,
    //       page: 'roaming-multi-country',
    //       categoryId: categoryId,
    //     },
    //   });
    // };
    return (
      <Swiper
        className="column_swiper_1 swiper_vertical_slide"
        spaceBetween={12}
        slidesPerView={data?.length <= 3 ? 1 : 1.1}
        grid={{ rows: 3, fill: "column" }}
        modules={[Grid, Pagination]}
        style={{ gridAutoFlow: "row", display: "grid" }}
      >
        {data?.map((item) => {
          return (
            <SwiperSlide>
              <CardsComponent
                type={20}
                data={item}
                psmItem={psmItem}
                categoryId={categoryId}
                bgColor={bgColor}
                categoryId_ar={categoryId_ar}
                categoryId_en={categoryId_en}
              ></CardsComponent>
            </SwiperSlide>
          );
        })}
      </Swiper>
    );
  }
  if (type === 12) {
    // console.log(data, "datadatadata");
    const handleRedirect = (item) => {
      if(flag === "true"){
        setDisplayText('digitalservices')
        setShow(true);

        return;
      }else{
        navigate(`/digitalservices-detail/${item.id}`, { state: {result: item, flag: flag} });
      }
    } 
    return (
      <>
      <Swiper
        className="column_swiper_1 swiper_vertical_slide"
        spaceBetween={12}
        slidesPerView={data?.length > 3 ? 1.1 : 1}
        grid={{ rows: 3, fill: "col" }}
        modules={[Grid, Pagination]}
      >
        {data?.map((item) => {
          //console.log(item, "datadata");
          return (
            <SwiperSlide
              onClick={() => {
                try{
                  GTM_Select_Item(item, "DigitalServices")
                }catch{}
                // navigate(`/digitalservices-detail/${item.id}`, { state: {result: item, flag: flag} });

                handleRedirect(item);
              }}
            >
              <CardsComponent type={18} data={item}></CardsComponent>
            </SwiperSlide>
          );
        })}
        {/* <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide>
            <SwiperSlide>
                <CardsComponent type={2}></CardsComponent>
            </SwiperSlide> */}
      </Swiper>

      <ExclusiveModal
        show={show}
        toggleModal={()=> setShow(!show)}
        deeplinktext={displaytext}
      />
      </>
    );
  }

  // Special deals postpaid swiper
  if (type === 13) {
    return (
      <>
        {
          (data?.response?.AvailableOffers === null ||
            data?.response?.AvailableOffers === undefined ||
            data?.response?.AvailableOffers === "" ||
            // data?.response?.AvailableOffers === [] ||
            data?.response?.AvailableOffers?.length == 0) ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> :
            <Swiper
              className="column_swiper_1 swiper_vertical_slide"
              style={{ gridAutoFlow: "row", display: "grid" }}
              spaceBetween={12}
              // slidesPerView={data?.response?.AvailableOffers?.length > 3 ? 1.1 : 1}
              // slidesPerView="auto"
              slidesPerView={
                data?.response?.AvailableOffers?.length > 3 ? 1.1 : 1
                }
              // grid={{ rows: 3, fill: "col" }}
              grid={{ rows: 3, fill: "column" }}
              modules={[Grid, Pagination]}
            >
              {data?.response?.AvailableOffers?.slice(0, 6)?.map((item) => {
                return (
                  <SwiperSlide>
                    <CardsComponent
                      type={19}
                      data={item}
                      psmItem={psmItem}
                    ></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </Swiper>
        }
      </>
    );
  }
  if (type === 14) {
    return <Swiper className='auto_swiper_2 video_swiper'
      spaceBetween={12}
      slidesPerView="1.5"
    >
      <SwiperSlide>
        <CardsComponent type={21}></CardsComponent>
      </SwiperSlide>
      <SwiperSlide>
        <CardsComponent type={21}></CardsComponent>
      </SwiperSlide>
    </Swiper>
  }

  if (type === 15) {
    let x = null
    return (
      <>
        {
          data?.response === null ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> :
            <Swiper
              className="column_swiper_1 swiper_vertical_slide"
              spaceBetween={12}
              style={{ gridAutoFlow: "row", display: "grid" }
              }
              slidesPerView={data?.response?.length > 3 ? 1.1 : 1}
              grid={{ rows: 3, fill: 'column' }}
              modules={[Grid, Pagination]}
            >
              {/* {console.log(
          data?.response?.slice(0, 6),
          "data?.response?.filter(item => item.length <= 6)"
        )} */}
              {

                data?.response?.slice(0, 6).map((item, i) => {
                  console.log(data, "data")
                  // console.log(data, "datesrrrr");
                  return (
                    <SwiperSlide
                      // style={{ display: "flex", order: i + 1 !== 1 ? ((i + 1) / 2 === 1 ? i + 1 : i -1) : 1 }}
                      onClick={() => {
                        try{
                          GTM_Select_Item(item, "bundles")
                        }catch{}
                        navigate(
                          `/bundles-detail/${data.id !== undefined ? data.id : item?.rnofferSubGroup
                          }`,
                          { state: item }
                        );
                      }}
                    >
                      <CardsComponent type={9} data={item}></CardsComponent>
                    </SwiperSlide>
                  );
                })
              }
            </Swiper >
        }
      </>
    );
  }

  // nojoom swipers
  if (type === 16) {
    const getSwiperContent = (section) => {
      switch (section) {
        case 'hot-deals':
          return (
            <>
              {data?.response?.dynamictypes && data?.response?.dynamictypes[0]?.cards?.map((item) => {
                return (
                  <SwiperSlide>
                    <CardsComponent type={22} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </>
          )

        case 'partners':
          const categoryList = getUniqueObjByKey(data?.response?.PartnersList, 'category')
          return (
            <>
              {categoryList?.map((item) => {
                return (
                  <SwiperSlide>
                    <CardsComponent type={23} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </>
          )

        case 'services':
          return (
            <>
              {data?.response?.map((item) => {
                return (
                  <SwiperSlide>
                    <CardsComponent type={24} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </>
          )

        case 'earn-points':
          return (
            <>
              {data?.response?.dynamictypes && data?.response?.dynamictypes[0]?.cards?.map((item) => {
                return (
                  <SwiperSlide>
                    <CardsComponent type={25} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </>
          )

        case 'transfer-points':
          return (
            <>
              {data?.response?.dynamictypes && data?.response?.dynamictypes[0]?.cards?.map((item) => {
                return (
                  <SwiperSlide>
                    <CardsComponent type={27} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </>
          )

        default:
          return <></>
      }
    }

    return (
      <>
        {
          data?.response === null ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> :
            <Swiper
              className="column_swiper_1"
              // spaceBetween={6}
              spaceBetween={12}
              // slidesPerView={data?.response?.dynamictypes?.cards?.length<=2?"auto":1.1}
              // slidesPerView={1.1}
              // slidesPerView="auto"
              slidesPerView={1.1}
              // grid={{ cols: 3, fill: "col" }}
              // modules={[Grid, Pagination]}
              breakpoints={{
                768:{
                  slidesPerView: 1.8,
                },
                0:{
                  slidesPerView:1.8
                }
              }}
            >
              {getSwiperContent(section)}
            </Swiper>
        }
      </>
    );
  }
  if (type === 17) {
    return (
      <Swiper
        className="column_swiper_1 swiper_vertical_slide"
        spaceBetween={12}
        slidesPerView={data?.length > 3 ? 1.1 : 1}
        grid={{ rows: 3, fill: "row" }}
        modules={[Grid, Pagination]}
      >
        {data?.map((item) => {
          return (
            <SwiperSlide>
              <CardsComponent type={26} data={item} giftnumber={giftnumber}></CardsComponent>
            </SwiperSlide>
          );
        })}
      </Swiper>
    )
  };

  if (type === 18) {
    return (
      <>
        {
          data?.response === null ? <>
            <div className="xpress_no_trans text-center" >
              <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
              />
              <div className="mb-5">
                <label>{t("noofferptal")}</label>
              </div>
            </div>
          </> : <>
          {
            section === 'dls_ooredoo_add' ? (
            <Swiper
              className="column_swiper_1"
              spaceBetween={6}
              // slidesPerView={data?.response?.length <= 2 ? "auto" : 1.1}
              slidesPerView="auto"
              grid={{ cols: 3, fill: "col" }}
              modules={[Grid, Pagination]}
            >
              {data?.response?.map((item) => {
                return (
                  <SwiperSlide className="w-50">
                    {/* <CardsComponent type={28} data={item}></CardsComponent> */}
                    <CardDLS data={item} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            ) : (
<Swiper
              className="column_swiper_1"
              spaceBetween={6}
              // slidesPerView={data?.response?.length <= 2 ? "auto" : 1.1}
              slidesPerView="auto"
              grid={{ cols: 3, fill: "col" }}
              modules={[Grid, Pagination]}
            >
              {data?.response?.map((item) => {
                return (
                  <SwiperSlide className="w-50">
                    <CardsComponent type={28} data={item}></CardsComponent>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            )
          }
          </>
            
        }
      </>
    );
  }

  if (type === 19) {
    return (
      <Swiper
        className="column_swiper_1 swiper_vertical_slide"
        spaceBetween={12}
        slidesPerView={data?.length > 3 ? 1.1 : 1}
        grid={{ rows: 3, fill: "row" }}
        modules={[Grid, Pagination]}
      >
        {data?.map((item) => {
          return (
            <SwiperSlide>
              <CardsComponent type={29} data={item}></CardsComponent>
            </SwiperSlide>
          );
        })}
      </Swiper>
    )
  };
  // recent-transaction
if (type === 20) {
  // console.log("SwiperComponent_type_4_data", data);
  return (
    <Swiper
      className="column_swiper_1"
      spaceBetween={12}
      slidesPerView={data?.length > 3 ? 1.1 : 1}
      grid={{ rows: 3, fill: "row" }}
      modules={[Grid, Pagination]}
    >
      {data?.map((item) => {
        return (
          <SwiperSlide>
            <CardsComponent type={30} data={item}></CardsComponent>
          </SwiperSlide>
        );
      })}
      {/* <SwiperSlide>
              <CardsComponent type={2}></CardsComponent>
          </SwiperSlide>
          <SwiperSlide>
              <CardsComponent type={2}></CardsComponent>
          </SwiperSlide>
          <SwiperSlide>
              <CardsComponent type={2}></CardsComponent>
          </SwiperSlide>
          <SwiperSlide>
              <CardsComponent type={2}></CardsComponent>
          </SwiperSlide>
          <SwiperSlide>
              <CardsComponent type={2}></CardsComponent>
          </SwiperSlide> */}
    </Swiper>
  );
}

//ooredoo add
if (type === 21) {
  return (
    <Swiper
    className={`swiper-container dls13_ooredooadd_swiper1 ${data?.response?.length == 1 ? 'oaddsingle' : ''}`}
      //className="dashboard_swiper"
      spaceBetween={12}
      //slidesPerView={1.1}
      slidesPerView={data?.response?.length > 2 ? 2.2 : 2}
      // breakpoints={{
      //   480:{
      //     slidesPerView: 1.5,
      //   },
      //   0:{
      //     slidesPerView:1.5
      //   }
      // }}
      //grid={{ rows: 3, fill: "row" }}
      //modules={[Grid, Pagination]}
    >
      {data?.response?.map((item) => {
        return (
          <SwiperSlide>
            <CardsComponent type={33} data={item}></CardsComponent>
          </SwiperSlide>
        );
      })}
    
    </Swiper>
  );
}
//recent purchase in home page single length 
if (type === 22) {
  return (
    <Swiper
      className="rect_card_swiper_1 mb-2"
      spaceBetween={12}
      // slidesPerView={data?.response?.length > 3 ? 1.1 : 1}
      pagination={{
        clickable: true
      }}
      // slidesPerView={1.1}
      // grid={{ rows: 3, fill: "row" }}
      // grid={{ rows: 1, fill: "row" }}
      grid={{ rows: 3, fill: "row" }}
      modules={[Grid, Pagination]}
    >
      <SwiperSlide>
        <CardsComponent
          type={37}
          data={data}
        ></CardsComponent>
      </SwiperSlide>
    </Swiper>
  );
}

};



export default SwiperComponent;
